export const formatCurrencyToApi = (value: any) => {
  if (value === "" || undefined || null) return 0;
  if(value?.startsWith("-")) {
    let valueWithoutRs = value?.split("$");
    return parseFloat(valueWithoutRs[1]?.replaceAll(".", "")?.replaceAll(",", ".")) * -1;
  }
  if (!value?.startsWith("R")) {
    return parseFloat(value?.replaceAll(".", "")?.replaceAll(",", "."));
  }
  let valueWithoutRs = value?.split("$");
  return parseFloat(valueWithoutRs[1]?.replaceAll(".", "")?.replaceAll(",", "."));
};
export const formatFromApiToInput = (value: any) => {
  if (value === "" || undefined || null) return "";
  return String(value)?.replace(".", ",");
};
export const formatStringAmountToApi = (value: any) => {
  if (value === "" || undefined || null) return 0;
  return parseFloat(String(value)?.replaceAll(".", "")?.replace(",", "."));
};